import type { PageAction } from "@octopusdeploy/design-system-components";
export function createGenerateAnnotationsPageAction(onClick: () => void, disabled: boolean = false): PageAction {
    return {
        type: "button",
        label: "Generate Annotations",
        buttonType: "secondary",
        onClick,
        disabled,
    };
}
